export const defaultErrorMessage = "The action was rejected by the server";
export const defaultErrorNotificationMessage = "Something went wrong";